import React from "react"
import styled from "styled-components"
import { Button, Card, CardBody, CardTitle, Col, Row } from "reactstrap"
import classnames from "classnames"
import TTCampaignSettings from "./TTCampaignSettings"
import { AvForm } from "availity-reactstrap-validation"
import IOSDedicatedCampaign, { IOS_DEDICATED_CAMPAIGN_KEY } from "./IOSDedicatedCampaign"
import TTCampaignBudget, { CAMPAIGN_BUDGET_KEY } from "./TTCampaignSettings/TTCampaignBudget"

// const FIELD_KEYS = {
//   campaignName: 'campaignName',
//   createSplitTest: 'createSplitTest',
//   campaignBudgetOptimization: 'campaignBudgetOptimization'
// }

const options = [
  {
    label: "Awareness",
    options: [
      { label: "Reach", description: "Show your ad to the maximum number of people.", items: ["createSplitTest", "campaignBudgetOptimization", CAMPAIGN_BUDGET_KEY] }
    ]
  }, {
    label: "Consideration",
    options: [
      {
        label: "Traffic",
        description: "Send more people to ad destination on your website or app.",
        items: ["createSplitTest", "campaignBudgetOptimization", CAMPAIGN_BUDGET_KEY]
      },
      // { label: "App installs", description: "Get more people to install your app.", items: ['createSplitTest', 'campaignBudgetOptimization'] },
      { label: "Video views", description: "Get more views and engagement for your video ads.", items: [CAMPAIGN_BUDGET_KEY] },
      {
        label: "Lead generation",
        description: "Collect leads for your business or brand.",
        items: ["createSplitTest", "campaignBudgetOptimization", CAMPAIGN_BUDGET_KEY]
      },
      {
        label: "Community interaction",
        description: "Get more followers or profile visits.",
        items: ["createSplitTest", "campaignBudgetOptimization", CAMPAIGN_BUDGET_KEY]
      }
    ]
  }, {
    label: "Conversion",
    options: [
      // { label: "Conversions", description: "Drive valuable actions on your website or app.", items: ['createSplitTest', 'campaignBudgetOptimization'] },
      {
        label: "Ad promotion",
        description: "Get more users to install and engage with your app.",
        items: ["createSplitTest", "campaignBudgetOptimization", IOS_DEDICATED_CAMPAIGN_KEY, CAMPAIGN_BUDGET_KEY]
      },
      {
        label: "Website conversions",
        description: "Drive valuable actions on your website.",
        items: ["createSplitTest", "campaignBudgetOptimization", CAMPAIGN_BUDGET_KEY]
      }
    ]
  }
]

const AdvertisingObjectiveContainer = ({}) => {
  const [value, setValue] = React.useState()
  const [data, setData] = React.useState({
    createSplitTest: false,
    campaignBudgetOptimization: false
  })
  const [isFormSubmit, setIsFormSubmit] = React.useState(false)

  const onChange = (params) => {
    setData(params)
  }

  const onSubmitForm = (e, errors, params) => {
    setIsFormSubmit(true)

    // console.log(e.isDefaultPrevented(), e.isPropagationStopped());
    console.log({ e, errors, params });

    // if (errors?.length !== 0) {
    //   const i = document
    //     .querySelector(".is-invalid")
    //     .parentNode.parentNode.getBoundingClientRect().top;
    //   window.scroll(undefined, i + window.scrollY - 150);
    // }

    if (errors?.length === 0) {
    }
  }

  return (
    <AdvertisingObjectiveContainerStyled>
      <Card>
        <CardBody>
          <CardTitle className="font-weight-semibold font-size-18">Advertising objective</CardTitle>
          <p className="text-muted mb-4">Choose the best advertising objective based on your campaign goals.</p>
          <Row>
            {options.map(el => <Col key={el.label}>
              <h3 className="mb-4">{el.label}</h3>
              <div className="cards-container">
                {el.options.map(i => <div className={classnames("card-item", { active: (value === i) })} key={i.label}
                                          onClick={() => setValue(i)}>
                  <h3>{i.label}</h3>
                  <p className="font-size-12">{i.description}</p>
                </div>)}
              </div>
            </Col>)}
          </Row>
        </CardBody>
      </Card>
      <AvForm className="needs-validation" onSubmit={onSubmitForm}>
        {value && <>
          <IOSDedicatedCampaign onChange={onChange} items={value.items} isFormSubmit={isFormSubmit} />
          <TTCampaignSettings data={data} onChange={onChange} items={value.items} isFormSubmit={isFormSubmit} />
          <Row>
            <Col xl={12}>
              <Card className="bg-transparent shadow-none">
                <Row>
                  <Col sm={12}>
                    <div className="text-start d-flex">
                      <Button
                        color="primary"
                        type="submit"
                        className={`float-start`}
                      >Continue</Button>
                    </div>
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>
        </>}
      </AvForm>
    </AdvertisingObjectiveContainerStyled>
  )
}

AdvertisingObjectiveContainer.propTypes = {}

const Settings = styled(CardBody)`
  .setting_campaign-name {
    input {
      background-color: #f5f5f5;
      transition: .2s;
      border-color: transparent;

      &:hover {
        background-color: #efefef;
      }

      &:focus, &:focus-visible {
        background-color: transparent !important;
        border-color: #ced4da;
      }
    }
  }
`

const AdvertisingObjectiveContainerStyled = styled.div`
  .cards-container {
    display: flex;
    width: 100%;
    flex-direction: column;

    .card-item {
      padding: 15px 25px;
      background-color: #f5f5f5;
      min-height: 115px;
      cursor: pointer;
      margin-bottom: 8px;
      border-radius: 5px;
      border: 2px solid transparent;
      //border-left-width: 4px;
      transition: .3s;

      &:hover {
        background-color: #efefef;
      }

      &.active {
        background-color: transparent !important;
        border-color: #556ee6 !important;
        cursor: initial !important;
      }
    }
  }

  h3 {
    font-weight: 600;
    font-size: 14px;
    margin-bottom: 10px;
  }
`

export default (AdvertisingObjectiveContainer)
